var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScorepoints(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 16,
    viewBox: "0 0 29 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9049 2.12939L8.04471 5.41337C5.62814 6.90744 3.3858 11.378 3.3075 14.3938H0C0 9.2074 2.76196 4.66529 6.9049 2.12939Z",
    fill: "#4682AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2805 1.66795L20.136 4.35262C18.9853 3.79962 16.7578 3.06453 14.5 3.06415C12.2365 3.06377 10.0008 3.79962 8.85004 4.35723L7.70559 1.67688C9.73124 0.607706 12.042 0 14.5 0C16.9488 0 19.2598 0.6031 21.2805 1.66795Z",
    fill: "#4682AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 14.394H25.6928C25.6145 11.3736 23.3675 6.89384 20.9417 5.40437L22.0815 2.125C26.2334 4.65629 29 9.203 29 14.394Z",
    fill: "#4682AF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8246 12.9011C13.2046 13.2762 13.0117 14.0771 13.3931 14.6922C13.7773 15.3118 14.5876 15.5061 15.2076 15.1307L15.6148 14.7487L20.3835 10.2241L14.188 12.752L13.8246 12.9011Z",
    fill: "#4682AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScorepoints);
export default __webpack_public_path__ + "static/media/scorepoints.95e353ce.svg";
export { ForwardRef as ReactComponent };